var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.container},[_c('fieldset',{class:_vm.$style.fields},[_c('InputValidator',{class:_vm.$style.inputContainer,attrs:{"config":{
        attribute: 'name',
        errorStyleExceptions: _vm.$style.hideEmptyError,
        name: _vm.nameAttributeName,
        placeholder: 'Public Key Name',
        readonly: _vm.collapsed ? true : false,
        type: 'text',
        validate: 'required',
        value: _vm.listItem.name,
      }},on:{"InputValidatorModel":_vm.handleInputChange}}),_c('TextareaValidator',{class:[
        _vm.$style.textarea,
        _vm.collapsed ? _vm.$style.textareaCollapsed : '',
      ],attrs:{"config":{
        attribute: 'public_key',
        errorStyleExceptions: _vm.$style.hideEmptyError,
        name: _vm.publicKeyAttributeName,
        placeholder: 'Public Key',
        spellcheck: false,
        value: _vm.listItem.public_key,
      }},on:{"InputValidatorModel":_vm.handleInputChange}})],1),_c('button',{class:_vm.$style.collapseButton,on:{"click":_vm.handleCollapseButtonClick}},[_c('CollapseCaret',{attrs:{"collapsed":_vm.collapsed}})],1),_c('span',{class:_vm.$style.createDate},[_vm._v(_vm._s(_vm.addedOn))])])
}
var staticRenderFns = []

export { render, staticRenderFns }